exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clientTimelineTabs-321d6{width:100%}.clientTimelineTabs-321d6 .ant-tabs-nav{margin:0;padding:12px 24px}.clientTimelineTabs-321d6 .ant-tabs-nav:before{border-bottom-color:#d9d9d9 !important}.clientTimelineTabs-321d6 .ant-tabs-ink-bar{display:none}", ""]);

// Exports
exports.locals = {
	"clientTimelineTabs": "clientTimelineTabs-321d6"
};